import Header from "../components/Header";
import DisclosureBanner from "../components/DisclosureBanner";
import LamalDeadlineBanner from "../components/LamalDeadlineBanner";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import Services from "../components/Services";
import Simulator from "../components/Simulator";
import TrustSection from "../components/TrustSection";
import GoogleReviews from "../components/GoogleReviews";
import FAQ from "../components/FAQ";
import ContactForm from "../components/ContactForm";
import BookingSection from "../components/BookingSection";
import Footer from "../components/Footer";

export default function LandingPage() {
  return (
    <div className="bg-white text-slate-900" data-testid="landing-page">
      <Header />
      <div className="pt-20">
        <DisclosureBanner />
        <LamalDeadlineBanner />
      </div>
      <main>
        <Hero />
        <HowItWorks />
        <Services />
        <Simulator />
        <TrustSection />
        <BookingSection />
        <GoogleReviews />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
